import { FloatableButton } from "./base/FloatableButton";
import { useState } from "react";
import { FloatingComponent } from "../base/FloatingComponent";
import { SupportArea } from "../SupportArea";
import { SupportChatSwitch } from "../chat/SupportChatSwitch";

export const RequestSupportButton = (props) => {
  const [showComponent, setShowComponent] = useState(false);
  

  const clicked = () => {
    setShowComponent(!showComponent);
    if (props.supportRequested) {
      props.supportRequested();
    }
  }

  const closeRequested = () => {
    setShowComponent(false);
    if (props.closeRequested) {
      props.closeRequested();
    }
  }

  return (
    <>
    {!showComponent && !props.showChat && (
    <FloatableButton floating={props.floating}>
      <SupportChatSwitch switch={clicked} />
    </FloatableButton>
    )}
    { (showComponent || props.showChat) &&
      <FloatingComponent onClose={() => setShowComponent(false)}>
        <SupportArea onClose={closeRequested} title={props.title}/>
      </FloatingComponent>
    }
    </>
  );
}